var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"document-file",attrs:{"href":_vm.src}},[_c('a-icon',{staticStyle:{"font-size":"40px","color":"#e9e9ea"},attrs:{"type":_vm.icon}}),_c('div',{staticClass:"overlay"},[_c('a-icon',{staticClass:"icon",staticStyle:{"font-size":"20px"},attrs:{"type":"download"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }